import 'react-perfect-scrollbar/dist/css/styles.css'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider, createMuiTheme, CssBaseline } from '@material-ui/core'
import GlobalStyles from 'src/components/GlobalStyles'
import { useDarkMode } from 'src/theme'
import 'src/mixins/chartjs'
import Routes from 'src/router/'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import jMoment from 'moment-jalaali'
import JalaliUtils from '@date-io/jalaali'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import SnackProvider from './components/SnackProvider'
// import { useOneTime } from './hooks/useOneTime'
import { TOKEN_FIELD_STORAGE } from './api/index'
import {
  getProfile,
  getUserProfileInfo,
  selectorUserProfile,
} from './app/slices/userSlice'

// user exam ithout profile completed

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })

const App = (props) => {
  const dispatch = useDispatch()
  const [theme, toggleDarkMode] = useDarkMode()
  const themeConfig = createMuiTheme(theme)
  const user = useSelector(selectorUserProfile)

  const checkExpired = () => {
    const expireTime = localStorage.getItem('token_expire')
    const dateNow = new Date().getTime()
    if (expireTime < dateNow) {
      localStorage.removeItem('token_expire')
      localStorage.removeItem(TOKEN_FIELD_STORAGE)
    }
  }

  React.useEffect(() => {
    if (!user) {
      dispatch(getProfile())
      dispatch(getUserProfileInfo())
    }
    checkExpired()
  }, [])

  // useOneTime(() => {
  //   dispatch(getProfile())
  //   // dispatch(getUserProfileInfo())
  // })
  return (
    <ThemeProvider theme={themeConfig}>
      <GlobalStyles />
      <CssBaseline />
      <SnackProvider>
        <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
          <Routes theme={theme} toggleDarkMode={toggleDarkMode} {...props} />
        </MuiPickersUtilsProvider>
      </SnackProvider>
    </ThemeProvider>
  )
}

App.propTypes = {
  props: PropTypes.object,
}

export default withTranslation()(App)
